// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__15cJ3","content":"LoadingAlert_content__pHUNJ"};